export default __webpack_public_path__ + "static/media/l.d1f7e39d.jpg";